import React, { Component } from 'react';
import './LandingPage.css';
import Device from '../../devices/device';
import { cls } from '../../packages/components';
import Marker from './components/Marker';
import ButtonBack from './components/ButtonBack';



class LandingPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            page: 0,
        }
        this.pages = props.lastSpecialPage ? [...props.pages, props.lastSpecialPage] : [...props.pages];
        this.setPage = this.setPage.bind(this);
        this.goToLastPage = this.goToLastPage.bind(this);
        this.goPageBack = this.goPageBack.bind(this);
        this.goBack = this.goBack.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
    }

    goBack() {
        if(this.props.history) {
            this.props.history.goBack();
        }
    }

    componentDidMount() {
        document && document.removeEventListener("keydown", this.onKeyPress, true);
        document && document.addEventListener("keydown", this.onKeyPress, true);    
        window.SpatialNavigation.focus('.marker.focusable');
    }

    componentWillUnmount() {
        document && document.removeEventListener("keydown", this.onKeyPress, true);
    }

    onKeyPress(e) {
        const keys =  Device.getDevice() && Device.getDevice().getKeys() || null;
        const currentKey = keys ? keys.getPressKey(e.keyCode) : null;
        switch(currentKey){
            case "BACK":
                e.preventDefault();
                e.stopPropagation();
                this.goBack();
                break;            
            default:
        }
    }

    goPageBack() {
        this.setPage(this.pages.length - 2, () => {
            window.SpatialNavigation.focus(`.marker.focusable:nth-of-type(${this.pages.length - 1})`)
        });
    }

    goToLastPage() {
        window.SpatialNavigation.focus('.marker.focusable:last-of-type')
    }

    setPage(page, callback = () => {}) {
        this.setState({page, isMarkerFocused: true}, callback)
    }
    
    render() {
        const page = this.pages[this.state.page]
        const isLastPage = this.props.lastSpecialPage && this.state.page === this.pages.length - 1

        return (
            <div>
                <div className="landing-page" style={{backgroundImage: `url("${page.props.backgroundImage}")`}}>
                    { page }
                    <div className={`landing-page_controls ${isLastPage ? "last-page" : ""}`}>
                        {
                            isLastPage 
                                ?   
                                    <div className="landing-page_markers">
                                        <ButtonBack onClick={this.goPageBack}/>
                                    </div>
                                :   
                                    <div className="landing-page_markers">
                                        {this.pages.map((_, index) => 
                                            <Marker key={index} onFocus={() => this.setPage(index)} /> 
                                        )}
                                    </div> 
                        }
                        <div className={cls(`landing-page_buttons`)}>
                            {
                                Array.isArray(page.props.buttons) && page.props.buttons.map((Button, index) => 
                                    <Button 
                                        key={index}
                                        history={this.props.history}
                                        goBack={this.goBack}
                                        goToLastPage={this.goToLastPage}
                                    /> )
                            }
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}

export default LandingPage;





// WEBPACK FOOTER //
// ./src/components/LandingPage/index.jsx